import {Button, Alert, IconButton, Stack} from '@mui/material';
import { useEffect, useState } from 'react';
import API from '../../../services/API';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Layout from "../../Frames/Layout"
import Loader from '../../Tools/Loader';
import { Delete, Edit } from '@mui/icons-material';
import Grid from "../../Tools/Grid";

export default function List(){

    const navigate = useNavigate()
    const [params] = useSearchParams()

    const [items, setItems] = useState(null)

    const [status, setStatus] = useState('loading')
    const statusIs = str => str === status

    const columns = [
        {
            field: 'title',
            headerName: 'Formation',
            width: 400,
            valueGetter: p => p.row.title
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 150,
            valueGetter: p => p.row.variant?.title
        },
        {
            field: 'value',
            headerName: 'Prix (€)',
            width: 80,
            type: 'number',
            valueGetter: p => p.row.price,
        },
        {
            field: 'duration',
            headerName: 'Durée (h)',
            width: 80,
            type: 'number',
            valueGetter: p => p.row.hours,
        },
        {
            field: 'reference',
            headerName: 'Code formation',
            width: 160,
            valueGetter: p => p.row.reference,
        },
        {
            field: 'category',
            headerName: 'Filière',
            width: 120,
            valueGetter: p => p.row.category?.title || 'Toutes',
        },
        {
            field: 'reference2',
            headerName: 'Référence',
            width: 150,
            valueGetter: p => p.row.reference2
        },
        {
            field: 'actions',
            headerName: '',
            width: 120,
            valueGetter: p => p.row.id,
            renderCell: p => 
                <Stack direction='row' spacing={1}>
                    <Link to={`/admin/prices/${p.value}`}>
                        <IconButton size='small'>
                            <Edit />
                        </IconButton>
                    </Link>
                    <IconButton size='small' onClick={() => handleDelete(p.value)}>
                        <Delete />
                    </IconButton>
                </Stack> 
        },
    ]

    useEffect(() => {

        API.get('/products?type=course')
            .then(r => {
                setStatus('ready')
                setItems(params.has('course') ? 
                    r.data.filter(p => p.reference === params.get('course')) :
                    r.data 
                )
            })
            .catch(e => setStatus('error'))

    }, [params])


    const handleDelete = id => {
        
        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer ce tarif ?")
        if(!ok) return false;

        let copy = [...items];
        copy = copy.filter(i => i.id !== id);

        API.delete(`/products/${id}`)
            .then(r => console.log(r.data))
            .catch(e => setItems([...items]))

        return setItems(copy);
    }


    return <Layout title="Tarifs des formations" tab="prices" menu="admin" back={true}>


        <Button  
            variant='contained' 
            onClick={() => navigate('/admin/prices/new')}
            sx={{mb: 1}}
        >
            Ajouter
        </Button>

        <Grid 
            id='pricesGrid'
            columns={columns}
            rows={items}
            toolbar
        />

        
        {statusIs('error') && 
            <Alert severity="error">Une erreur s'est produite.</Alert>
        }

        {statusIs('loader') && 
            <Loader />
        }

    </Layout>
}

